// create pinia store
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSettingStore = defineStore('settingStore', () => {

    const language = ref('en')

    const setLanguage = (lang) => {
        language.value = lang
    }

    return {
        language,
        setLanguage
    }
},
{
    persist : true,
    paths : [
        'language'
    ]
})